import React from 'react';

import { Camera } from 'types/camera';

import { useDeployments } from 'deployments/hooks/useDeployments';
import { useMqttDeploymentsState } from 'deployments/hooks/useMqttDeploymentsState';

import { Loader } from 'components/Loader/Loader';
import { Separator } from 'components/Separator/Separator';
import { Text } from 'components/Text/Text';
import { Tooltip } from 'components/Tooltip/Tooltip';

import { ReferenceDeploymentsList } from './List';

const limit = 3;

type UniversalBridgeDeploymentsProps = {
  camera: Camera;
  pipeline_id?: string;
};

export function UniversalBridgeDeployments({
  camera,
  pipeline_id,
}: UniversalBridgeDeploymentsProps) {
  const isEnabled = Boolean(camera.reference_deployment_ids.length);

  const [page, setPage] = React.useState(1);

  const queryResult = useDeployments({
    params: {
      page,
      limit,
      deployment_ids: camera.reference_deployment_ids,
      ...(pipeline_id ? { pipeline_ids: [pipeline_id] } : {}),
    },
    enabled: isEnabled,
    keepPreviousData: true,
  });

  const { data: referenceDeployments, isInitialLoading } = queryResult;

  useMqttDeploymentsState(
    referenceDeployments?.data
      ? referenceDeployments.data.map(({ id }) => id)
      : []
  );

  // FIXME A SkeletonTable would be better here
  if (!referenceDeployments && isInitialLoading) {
    return <Loader size="small" text="Loading..." />;
  }

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      {!pipeline_id && (
        <>
          <Separator />
        </>
      )}
      <Tooltip
        side="right"
        content={
          <Text type="paragraph">
            This workflow configuration is applied to every new uploaded clip
            associated with this camera.
          </Text>
        }
      >
        <Text type="paragraph">Workflow configuration</Text>
      </Tooltip>
      <ReferenceDeploymentsList
        queryResult={queryResult}
        pageSize={limit}
        page={page}
        onPageChange={setPage}
      />
    </>
  );
}
